import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useAwaitControl } from 'react-redux-await-control';

import ContractFieldsPanel, { ContractFieldsData } from '~/components/ContractFieldsPanel';
import Summary from '~/screens/Contract/components/Tabs/Summary/Summary';
import { getDatavalid } from '~/store/people/actions';
import { getLoggedUser } from '~/store/user/actions';
import useUserRoles from '~/hooks/useUserRoles';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractMoreDetailsProps = {
  contractId: string;
  // eslint-disable-next-line react/no-unused-prop-types
  contractIds: string[];
  // eslint-disable-next-line react/no-unused-prop-types
  loading: boolean;
  contractDetails: any;
  onBack: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onContractChange: (id: string) => void;
};

export function ContractMoreDetails({ contractId, contractDetails, onBack }: ContractMoreDetailsProps) {
  const dispatch = useDispatch();
  const { hasRole } = useUserRoles();

  const getDatavalidControl = useAwaitControl(getDatavalid);
  const getLoggedUserControl = useAwaitControl(getLoggedUser);

  const infos = getDatavalidControl.result();
  const user = getLoggedUserControl.result();

  const showAgreementPassword = hasRole('AGREEMENT_PASSWORD');
  const canEditBornDate = hasRole('PROFILE_EDITOR');

  useEffect(() => {
    if (contractDetails?.person?.id) {
      dispatch(getDatavalid.start({ personId: contractDetails.person.id, forceUpdate: false }));
    }
  }, [contractDetails?.person?.id]);

  const data = useMemo<ContractFieldsData>(
    () => ({
      ...contractDetails,
      infos,
      showAgreementPassword,
      canEditBornDate,
      user,
      contractIdParam: contractId,
    }),
    [contractDetails, infos, showAgreementPassword, canEditBornDate, user, contractId],
  );

  const isBackofficeContract = !!contractDetails?.contract;

  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      {isBackofficeContract ? (
        <Summary contract={contractDetails} compact />
      ) : (
        <ContractFieldsPanel data={data} compact />
      )}
    </div>
  );
}
